import React from "react";
import Navbar from "./Navbar";
import SEO from "../SEO";
import Footer from "./Footer";
import styled from "styled-components";

export default function Layout({ children, title, description }) {
	return (
		<Wrapper>
			<SEO title={title} description={description} />
			<Navbar />
			<Main>{children}</Main>
			<Footer />
		</Wrapper>
	);
}

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: space-between;
	max-width: 100vw;
	min-height: 100vh;
`;

const Main = styled.main`
	justify-self: flex-start;
	width: 100%;
	min-height: 20vh;

	section {
		padding: 7.8rem 7.5rem 0;

		.bp {
			background-color: #edeaea !important;
		}

		&:last-child {
			padding-bottom: 7.8rem;
		}

		@media (max-width: 768px) {
			padding: 3.8rem 1.3rem 0;

			&.no-pt {
				padding-top: 0;
			}

			&.no-pb {
				padding-bottom: 0 !important;
			}

			&.no-py {
				padding-top: 0 !important;
				padding-bottom: 0 !important;
			}

			&.no-px {
				padding-right: 0 !important;
				padding-left: 0 !important;
			}

			&.no-p {
				padding: 0 !important;
			}

			&:last-child {
				padding-bottom: 3.8rem;
			}
		}
	}
`;
